import { render, staticRenderFns } from "./MaliciousConsumer.vue?vue&type=template&id=125e3844&scoped=true"
import script from "./MaliciousConsumer.vue?vue&type=script&lang=js"
export * from "./MaliciousConsumer.vue?vue&type=script&lang=js"
import style0 from "./MaliciousConsumer.vue?vue&type=style&index=0&id=125e3844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125e3844",
  null
  
)

export default component.exports